require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-stability-an-open-letter-from-code-fellows-ceo.json") })
        }
      }, "path---blog-stability-an-open-letter-from-code-fellows-ceo");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-stability-an-open-letter-from-code-fellows-ceo!./.cache/json/blog-stability-an-open-letter-from-code-fellows-ceo.json
// module id = 1084
// module chunks = 231608221292675